import React, { FC } from 'react';
import Modal from 'components/shared/Modal';
import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { LinkShortenerApi } from 'api/linkShortener';
import ArrayUtils from 'app/utils/array';
import { formatDateTimeUTCToLocalTimezone } from 'app/utils/date';
import { Button, Field } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { LinkSource } from 'types/LinkShortener';

type Props = {
  onClose: AnyFunction;
  linkId?: string;
  source?: LinkSource;
};

const skeletons = ArrayUtils.generate(4);

const StatisticsModal: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery(
    [queryKey.shortenLinkDetail, props.linkId],
    () =>
      LinkShortenerApi.detail(
        props.linkId as string,
        props.source as LinkSource,
      ),
    { enabled: !!props.linkId && !!props.source },
  );

  return (
    <Modal
      id="shorten-link-detail-modal"
      onClose={props.onClose}
      open={!!props.linkId}
      classNames={{
        root: '!tw-z-[1002]',
      }}
    >
      <Modal.Header title={t('linkShortener.statistics.title')} />
      <Modal.Content>
        {data && (
          <div className="tw-flex tw-flex-col tw-gap-4 tw-break-all">
            <Field.Group>
              <Field.Label required>
                {t('linkShortener.statistics.shortenedUrl')}
              </Field.Label>
              <span>{data.shortUrl}</span>
            </Field.Group>
            <Field.Group>
              <Field.Label required>
                {t('linkShortener.statistics.url')}
              </Field.Label>
              <span>{data.url}</span>
            </Field.Group>
            <Field.Group>
              <Field.Label required>
                {t('linkShortener.statistics.created')}
              </Field.Label>
              <span>
                {data.createdAt
                  ? formatDateTimeUTCToLocalTimezone(data.createdAt)
                  : '-'}
              </span>
            </Field.Group>
            <Field.Group>
              <Field.Label required>
                {t('linkShortener.statistics.updated')}
              </Field.Label>
              <span>
                {data.updatedAt
                  ? formatDateTimeUTCToLocalTimezone(data.updatedAt)
                  : '-'}
              </span>
            </Field.Group>
            <Field.Group>
              <Field.Label required>
                {t('linkShortener.statistics.clicks')}
              </Field.Label>
              <span>{data.totalClicks}</span>
            </Field.Group>
          </div>
        )}
        {isLoading &&
          skeletons.map((i) => (
            <div className="tw-mt-2" key={i}>
              <Skeleton height={40} />
            </div>
          ))}
      </Modal.Content>
      <Modal.Footer>
        <Button onClick={props.onClose} variant="secondary">
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatisticsModal;
